import React, { useContext } from "react";
import { ThemeContext } from "../../context/ThemeProvider";
import { getThemeTextColor } from "../../utils/themeUtils";
import { IMAGES } from "../../assets";

const InfoPopup = ({ title, message, onClose }) => {
  const { theme, currentTheme } = useContext(ThemeContext);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 dark:bg-opacity-60 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-lg w-11/12 max-w-md relative">
        <button
          className="absolute right-4 top-4 text-gray-500 hover:text-gray-800 dark:text-gray-300 dark:hover:text-white"
          onClick={onClose}
        >
            <img className="w-4 h-4" src={IMAGES.ic_cancel} />
        </button>
        <h2 className="text-lg font-semibold mb-3" style={{ color: getThemeTextColor(theme, currentTheme) }}>
          {title}
        </h2>
        <p className="text-base" style={{ color: getThemeTextColor(theme, currentTheme) }}>
          {message}
        </p>
      </div>
    </div>
  );
};

export default InfoPopup;
